import { formatAddress } from '@if/core/utils'
import { Link, Typography, TypographyProps } from '@mui/material'
import { Address } from '../data/types'

interface Props {
  address: Address | null
  typographyProps?: TypographyProps
  component?: React.ElementType
}

const AddressWithGoogleSearch = ({ address, typographyProps, component = 'span' }: Props) => {
  const getGoogleSearchUrl = (addressText: string) => {
    const searchQuery = encodeURIComponent(addressText)
    return `https://www.google.com/search?q=${searchQuery}`
  }

  if (!address) {
    return (
      <Typography component={component} {...typographyProps}>
        {/* Empty or fallback content when address is null */}
      </Typography>
    )
  }

  const formattedAddress = formatAddress(address)

  return (
    <Link
      href={getGoogleSearchUrl(formattedAddress)}
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      sx={{ cursor: 'pointer' }}
    >
      <Typography component={component} {...typographyProps}>
        {formattedAddress}
      </Typography>
    </Link>
  )
}

export default AddressWithGoogleSearch
